import { render, staticRenderFns } from "./PoiRegHistReportByHour.vue?vue&type=template&id=65bc5c70"
import script from "./PoiRegHistReportByHour.vue?vue&type=script&lang=js"
export * from "./PoiRegHistReportByHour.vue?vue&type=script&lang=js"
import style0 from "./PoiRegHistReportByHour.vue?vue&type=style&index=0&id=65bc5c70&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports